import React from 'react';
import { withStyles } from 'material-ui/styles';
import Paper from 'material-ui/Paper';
import Grid from 'material-ui/Grid';
import { GridList, GridListTile } from 'material-ui/GridList';
import ImageExtractor from './extractor/image.js';

const styles = theme =>({
  root: {
    marginTop: 25,
    marginBottom: 25,
    padding: 10,
  },
  images : {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
  },
  gridList: {
    display: 'flex',
    flexWrap: 'wrap',
    direction: 'row',
    justify: 'flex-start',
    alignItems: 'flex-start',
  },
  list : {
    display: 'block',
    overflowX: 'scroll',
    overflow: 'auto',
  },
  hlist: {
    display: 'flex',
  },
  hlist_item:{
    display: 'block',
    minWidth: 200,
    padding: 10,
    marginRight: 5,
  },
  title : {
    fontSize: 10,
    fontWeight: 500,
  },
  text : {
    fontSize: 10,
    fontWeight: 200,
    textAlign: 'justify',
  },
});

class SearchResultsItemTop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };

    this.getImages = this.getImages.bind(this);
  }

  componentDidMount() {
  }

  getImages(){
    const images = [];
    var item, i, image;

    const extractor = new ImageExtractor();

    for(i in this.props.results.items){
      item = this.props.results.items[i];
      image = extractor.extract(item);
      if(image.has_data){
        item = images.find((item)=>{return (item.src === image.src) ? item : null;});
        if(item) continue;

        if(image.height < image.width){
          image.cols = Math.round(image.width / image.height);
          image.rows = 1;
        } else {
          image.cols = 1;
          image.rows = Math.round(image.height / image.width);
        }
        images.push(image);
      }       
    }

    return images;
  }

  render() {
    const classes = this.props.classes;
    var key = 0;
    return (
      <Paper className={classes.root} elevation={5}>
        <Grid container>
          <Grid item xs={12}>
          {this.props.results.meanings && this.props.results.meanings.length > 0 &&
            this.renderMeanings() 
          } 
          </Grid>
          <Grid item xs={12}>
          {this.props.results.tweets && this.props.results.tweets.length > 0 &&
            this.renderTweets()
          }
          </Grid>
          <Grid item xs={12}>
            {this.renderImages()}
          </Grid>
        </Grid>
      </Paper>
    )
  }

  renderMeanings(){
    const classes = this.props.classes;
    var key = 0;
    return (
      <Grid container>
        <Grid item xs={12}>
          <h6>Context</h6>
          <div className={classes.list}>
            <div className={classes.hlist}>
            {this.props.results.meanings && this.props.results.meanings.map(meaning => 
              <div key={key++} className={classes.hlist_item}>
                <a href={`./#/?q=${meaning.meaning}`}>
                  <div className={classes.title}>{meaning.meaning}</div>
                  <div className={classes.text}>{meaning.text}</div>
                </a>
              </div>
            )}
            </div>
          </div>
        </Grid>
      </Grid>
    );
  }

  renderTweets(){
    const classes = this.props.classes;
    var key = 0;
    return (
      <Grid container>
        <Grid item xs={12}>
          <h6>Twitter</h6>
          <div className={classes.list}>         
            <div className={classes.hlist} >
            {this.props.results.tweets && this.props.results.tweets.map(tweet => 
              <div key={key++} className={classes.hlist_item}>
                <a href={tweet.link}>
                  <div className={classes.title}>{tweet.user}</div>
                  <div className={classes.text}>{tweet.text}</div>
                </a>
              </div>
            )}
            </div>
          </div>
        </Grid>
      </Grid>
    );
  }

  renderImages(){
    const classes = this.props.classes;
    const images = this.getImages();    
    var key = 0;
    return (
      <Grid container>
        <Grid item hidden={{xsDown : true}} sm={12}>
          <h6>Images</h6>
          <div className={classes.images}>
            <GridList cellHeight={100} className={classes.gridList} cols={12}>
              {images.map(tile => (
                <GridListTile key={key++} cols={tile.cols}>
                  <img src={tile.src} alt={tile.description} />
                </GridListTile>
              ))}
            </GridList>
          </div>
        </Grid>
        <Grid item hidden={{smUp : true}} xs={12}>
          <h6>Images</h6>
          <div className={classes.images}>
            <GridList cellHeight={50} className={classes.gridList} cols={12}>
              {images.map(tile => (
                <GridListTile key={key++} cols={tile.cols * 2}>
                  <img src={tile.src} alt={tile.description} />
                </GridListTile>
              ))}
            </GridList>
          </div>
        </Grid>
      </Grid>
    );
  }

}

export default withStyles(styles)(SearchResultsItemTop);


// WEBPACK FOOTER //
// ./src/search/search_results_item_top.js